import styled from "styled-components";
import { useState, useContext, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import { OrgTreeContext } from "../../../Contexts/OrgTreeContext";
import { CurrentUserContext } from "../../../Contexts/CurrentUserContext";
import { findNodeById } from "../../../Helpers/OrgTreeFunctions";

const TeamSelectorWrapper = styled.div`
  .p-dropdown {
    min-width: 160px;
  }
  @media (max-width: 400px) {
    .p-dropdown {
      min-width: none;
      height: 40px;
    }
  }
`;

export default function TeamSelector(props: Props) {
  const { selectedTeam, setSelectedTeam } = props;
  const orgTree = useContext(OrgTreeContext);
  const userContext = useContext(CurrentUserContext);
  const user = userContext?.currentUser;
  const [reportBuckets, setReportBuckets] = useState<ReportBucket[]>([]);

  useEffect(() => {
    if (user && orgTree) {
      let teams: string[] = [];
      const rolesToCheck = [
        "churchStaff",
        "volunteer",
        "pastoralCare",
        "oversight",
      ];

      user.PCRoles.forEach((role) => {
        if (
          rolesToCheck.some((r) => role.role.includes(r)) &&
          !teams.includes(role.teamId)
        ) {
          teams.push(role.teamId);
        }
      });

      let reportBuckets = teams.map((teamId) => {
        const teamLabel = findNodeById([orgTree], teamId)?.label;
        return {
          teamId,
          label: teamLabel ? teamLabel : "",
          reports: [] as ReportData[],
        };
      });
      setReportBuckets(reportBuckets);
    }
  }, [user, orgTree]);
  return (
    <TeamSelectorWrapper>
      <Dropdown
        inputId="dd-city"
        value={selectedTeam}
        onChange={(e) => setSelectedTeam(e.value)}
        options={reportBuckets.map((bucket) => {
          return { name: bucket.label, value: bucket.teamId };
        })}
        optionLabel="name"
        className="w-full md:w-14rem"
      />
    </TeamSelectorWrapper>
  );
}

interface Props {
  selectedTeam: string | undefined;
  setSelectedTeam: React.Dispatch<React.SetStateAction<string | undefined>>;
}

interface ReportBucket {
  teamId: string;
  label: string;
  reports: ReportData[];
}
